import React, { useState, useEffect } from 'react';

// Contatore circolare compatto (Variante 2): anello sottile con SOLO la percentuale al centro.
// Il numero assoluto e la dicitura stanno a destra nella card. `color` può essere una CSS var
// (es. 'var(--color-tim)') -> applicata via style, non come attributo, per risolverla.
export default function KpiRing({ pct, color, size = 60, stroke = 7, center = null }) {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const p = Math.max(0, Math.min(100, Math.round(pct || 0)));
  const cn = size / 2;
  // parte da vuoto e si riempie (transizione) al mount
  const [shown, setShown] = useState(false);
  useEffect(() => { const id = requestAnimationFrame(() => setShown(true)); return () => cancelAnimationFrame(id); }, []);
  const off = shown ? c * (1 - p / 100) : c;
  return (
    <div style={{ position: 'relative', width: size, height: size, flex: '0 0 auto' }}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} style={{ transform: 'rotate(-90deg)', display: 'block' }}>
        <circle cx={cn} cy={cn} r={r} fill="none" stroke="rgba(128,128,128,.2)" strokeWidth={stroke} />
        <circle cx={cn} cy={cn} r={r} fill="none" strokeWidth={stroke} strokeLinecap="round"
          style={{ stroke: color, strokeDasharray: c, strokeDashoffset: off, transition: 'stroke-dashoffset .6s ease' }} />
      </svg>
      <div style={{ position: 'absolute', inset: 0, display: 'grid', placeItems: 'center' }}>
        {center != null ? center : <span style={{ fontSize: size * 0.25, fontWeight: 800, color }}>{p}%</span>}
      </div>
    </div>
  );
}
